import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import * as icons from '@boxine/tonies-ui/icons';
import { media } from '../themes/theme';
import Icon from '../Icon';
import { spacings } from '../themes/variables';
function getBackgroundColor(type, theme) {
    switch (type) {
        case 'successOnWhite':
            return theme.colors.white;
        case 'successOnColor':
            return theme.colors.lightgrey;
        case 'info':
        default:
            return theme.colors['lightblue-20'];
    }
}
function getIconColor(type, theme) {
    switch (type) {
        case 'successOnWhite':
        case 'successOnColor':
            return theme.colors['green-100'];
        case 'info':
        default:
            return theme.colors['lightblue-100'];
    }
}
function getIconType(type) {
    switch (type) {
        case 'successOnWhite':
        case 'successOnColor':
            return icons.checkmarkFill;
        case 'info':
        default:
            return icons.exclamationMarkFill;
    }
}
export const StyledWrapper = styled.div `
  background-color: ${props => getBackgroundColor(props.type, props.theme)};
  border-radius: 1.625rem;
  color: ${props => props.theme.colors['darkergrey']};
  display: flex;
  align-items: center;
  font-size: 0.75rem;
  font-weight: 300;
  line-height: 1.33;
  padding: ${spacings['spacing-xs']} ${spacings['spacing-s']}
    ${spacings['spacing-xs']} ${spacings['spacing-xs']};
  max-width: fit-content;
  margin-left: auto;
  margin-right: auto;

  ${media.laptop `
    border-radius: 1rem;
    padding: 0.438rem 0.5rem;
    line-height: 1.125;
  `};
`;
export const StyledIcon = styled(Icon) `
  height: 2rem;
  width: 2rem;
  min-width: 2rem;
  margin-right: ${spacings['spacing-s']};

  ${media.mobileL `
    height: 1rem;
    width: 1rem;
    min-width: 1rem;
    margin-right: ${spacings['spacing-xs']};
  `};
`;
export const InfoBox = ({ children, className, type, }) => {
    const theme = useContext(ThemeContext);
    return (React.createElement(StyledWrapper, { className: className, type: type },
        React.createElement(StyledIcon, { type: getIconType(type), fill: getIconColor(type, theme) }),
        children));
};
